/* ============================================================
   HIT: filtros da coleção e da busca. A barra enxuta, a gaveta "Filtros" e a troca da lista sem recarregar a página.
   Portado de projetos/design-propostas/direcao-b/index.html (abreG e conteudoFiltro, 1440-1475; esqueleto, 917; o toast do aviso) e
   redesenhado nos apontamentos de 28/10/2026 (item 8): um botão "Filtrar" no lugar da parede de pílulas.

     window.HitFiltros = { vaiTrocar }

   MARCAÇÃO. É do snippets/filtros.liquid (contrato no topo dele): a barra .filtros[data-filtros] (botão Filtrar, Ordenar, total), e dentro dela a
   fonte [data-filtros-fonte] com um details.grupo por filtro, cada um com um <form data-filtro-form> GET; depois dela, os chips dos filtros ativos
   (.filtros-ativos). Sem este script os formulários funcionam (cada envio troca de página); com ele o envio e os links [data-filtro-link]
   (opção ativa, "Tirar", chips, "Limpar", o estado vazio) viram uma troca no lugar, e o Ordenar da barra envia ao mudar.
   TROCA (PLANO T16 passo 4). Busca a mesma URL com &section_id=<data-section-id do [data-filtravel]> (Section Rendering API), troca os
   filhos da seção, religa os trilhos (HitTrilhos) e escreve a URL com pushState. O voltar e o avançar (popstate) buscam de novo.
   AbortController cancela o pedido anterior; a lista vira esqueleto depois de 300 ms de espera; se falhar, o aviso "Não deu para filtrar
   agora. Tente de novo." e nada muda (a URL também fica). Link com Ctrl, Cmd, Shift ou botão do meio segue o caminho normal.
   PEDIDO EM VOO. A URL só é escrita depois de a lista trocar, então um voltar/avançar (ou um clique na lista que já está na tela) que não pede
   nada ainda assim decide o que a pessoa vê: cancelaLista() aborta o pedido da escolha anterior e invalida a resposta que ainda chegar. No
   voltar/avançar que falha a URL já é a nova e a grade é a velha: sem como manter as duas iguais, a página recarrega (location.reload, que
   deixa as entradas do histórico como estão). Se o voltar foi cancelado por um clique (na lista da tela, ou numa escolha que falhou), a URL
   do voltar ficaria com a grade de antes: realinhaGrade() busca a lista da URL da barra (e, se esse pedido também falha, a página recarrega).
   A entrada do histórico é a que a pessoa escolheu: nunca se reescreve com replaceState (apagaria a entrada do voltar), é a grade que vai até a URL.
   GAVETA. Registrada em HitGaveta como "filtros". Gatilho: o "Filtrar" da barra ou o da barra de baixo do celular. Ela mostra TODOS os grupos
   como acordeões (details.grupo): fechados, menos os que têm valor ativo, e o pé fixo com "Limpar" e "Ver N produtos" (que fecha). Aberta, ela
   acompanha cada troca: corpo, pé e título são refeitos com a rolagem, o foco no mesmo lugar (a opção, pela data-chave) e cada acordeão como a
   pessoa o deixou. Fecha com Esc, véu, × e "Ver N", e o foco volta ao botão que abriu (HitCamadas); o "Filtrar" da barra é um nó que a troca reaproveita.
   ESGOTADOS (D5, 19/10/2026). Nenhum pedido leva filter.v.availability: a lista traz os esgotados, e o main-collection os põe depois dos disponíveis.
   FOCO. Fechada a gaveta, o HitCamadas devolve o foco ao gatilho; se o botão de origem saiu do DOM na troca, o foco vai para o "Filtrar" da barra
   (ou o da barra de baixo), não para o body. Quem estava no Ordenar da barra ou num chip também volta a um controle da barra depois da troca.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.HitFiltros) return;

  const RAIZ = '[data-filtravel]';
  const BARRA = '[data-filtros]';
  const FONTE = '[data-filtros-fonte]';
  const GAVETA = '#gaveta';
  const ESPERA_ESQUELETO = 300; // ms (B: esqueleto depois de 300 ms)
  const AVISO_MS = 3600;
  const PRESERVA = ['preview_theme_id', 'pb']; // a prévia do rascunho: o pedido e a URL nova a mantêm
  const DESK = window.matchMedia('(min-width:900px)');
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  let controle = null;        // AbortController do pedido em curso
  let numero = 0;             // sobe a cada pedido: só o último vale
  let emVoo = null;           // { meu } do pedido em curso; null sem pedido
  let esq = null;             // { grade, conta, contaHtml } enquanto o esqueleto está na tela
  let relogio = 0;
  let origemGaveta = null;    // quem abriu a gaveta de filtros (o Filtrar da barra ou o da barra de baixo)
  let numeroErroPreco = 0;

  /* a URL que a página desenha, sem o que não muda a lista: section_id e #âncora */
  function chave(href) {
    const u = new URL(href, window.location.href);
    u.searchParams.delete('section_id');
    u.hash = '';
    return u.pathname + u.search;
  }
  let atual = chave(window.location.href);
  const vaiTrocar = () => chave(window.location.href) !== atual;
  const lugarDaEntrada = () => (window.history.state && typeof window.history.state.y === 'number' ? window.history.state.y : null);
  /* a barra aponta para uma lista que não está na tela: um voltar/avançar cujo pedido morreu (um clique na lista da tela, ou outra escolha
     que falhou) deixa a URL do voltar com a grade de antes. A entrada é a que a pessoa escolheu, e reescrevê-la (replaceState) apagaria uma
     entrada do histórico: a grade é que vai até a URL. Se esse pedido falha, troca() recarrega a página */
  function realinhaGrade() {
    if (!vaiTrocar()) return;
    troca(window.location.href, { empurra: false, lugar: lugarDaEntrada() });
  }

  function urlDe(destino) {
    const u = new URL(destino, window.location.href);
    u.searchParams.delete('section_id');
    u.hash = '';
    const aqui = new URL(window.location.href);
    PRESERVA.forEach((p) => { if (aqui.searchParams.has(p) && !u.searchParams.has(p)) u.searchParams.set(p, aqui.searchParams.get(p)); });
    return u;
  }

  /* ---------- avisos ---------- */
  function toast(msg) {
    const t = document.getElementById('toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(relogio);
    relogio = setTimeout(() => { t.hidden = true; }, AVISO_MS);
  }
  const texto = (nome) => { const b = $(BARRA); return (b && b.getAttribute('data-t-' + nome)) || ''; };
  /* o leitor de tela só lê o que muda num nó que continua: a frase vai numa região viva própria */
  function anuncia(frase) {
    if (!frase) return;
    let r = document.getElementById('filtros-status');
    if (!r) {
      r = document.createElement('p');
      r.id = 'filtros-status';
      r.className = 'sr';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      document.body.appendChild(r);
    }
    r.textContent = frase;
  }

  /* ---------- esqueleto (B:917) ---------- */
  function mostraEsqueleto(raiz) {
    const grade = $('.grade', raiz);
    if (esq || !grade) return;
    const conta = $('.conta', raiz);
    esq = { grade, conta, contaHtml: conta ? conta.innerHTML : '', contaClasse: conta ? conta.className : '' };
    const n = DESK.matches ? 8 : 6;
    let cards = '';
    for (let i = 0; i < n; i += 1) {
      cards += '<article class="card"><div class="tile"></div><div class="cmeta"><div class="barra-e c"></div><div class="barra-e"></div><div class="barra-e l"></div>'
        + (i % 3 === 0 ? '<div class="pilha-e"></div>' : '') + '</div></article>';
    }
    const lista = document.createElement('div');
    lista.className = 'grade esq';
    lista.setAttribute('aria-busy', 'true');
    lista.setAttribute('aria-label', texto('grade'));
    lista.innerHTML = cards;
    esq.lista = lista;
    grade.replaceWith(lista);
    if (conta) { conta.textContent = texto('carregando'); conta.classList.add('carr-msg'); conta.setAttribute('aria-live', 'polite'); }
  }
  function tiraEsqueleto() {
    if (!esq) return;
    if (esq.lista.isConnected) esq.lista.replaceWith(esq.grade);
    if (esq.conta && esq.conta.isConnected) { esq.conta.innerHTML = esq.contaHtml; esq.conta.className = esq.contaClasse; esq.conta.removeAttribute('aria-live'); }
    esq = null;
  }

  /* ---------- pedido ---------- */
  async function buscaSecao(url, id, sinal) {
    const req = new URL(url.href);
    req.searchParams.set('section_id', id);
    const r = await fetch(req.href, { signal: sinal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const nova = doc.querySelector(RAIZ);
    if (!nova) throw new Error('a resposta não traz a seção');
    return { doc, nova };
  }

  /* ---------- troca ---------- */
  function igualaAtributos(velho, novo) {
    Array.from(velho.attributes).forEach((a) => { if (a.name !== 'aria-expanded' && !novo.hasAttribute(a.name)) velho.removeAttribute(a.name); });
    Array.from(novo.attributes).forEach((a) => { if (a.name !== 'aria-expanded') velho.setAttribute(a.name, a.value); });
    velho.replaceChildren(...Array.from(novo.childNodes)); // o ícone e a contagem vão junto: textContent os apagaria
  }
  /* o "Filtrar" da barra é o nó que a gaveta guarda como origem (e que recebe o foco de volta ao fechar): o nó antigo continua, com o conteúdo novo */
  const botaoFiltrar = (escopo) => $('.filtros [data-gaveta="filtros"]', escopo);

  function trocaTudo(raiz, nova) {
    const antigo = botaoFiltrar(raiz);
    const rolagens = $$('[data-tri]', raiz).map((n) => [n.getAttribute('data-tri'), n.scrollLeft]);
    raiz.replaceChildren(...Array.from(nova.childNodes).map((n) => document.adoptNode(n)));
    const novo = botaoFiltrar(raiz);
    if (antigo && novo && antigo.tagName === novo.tagName) {
      igualaAtributos(antigo, novo);
      novo.replaceWith(antigo);
    }
    rolagens.forEach(([nome, x]) => { const el = $('[data-tri="' + nome + '"]', raiz); if (el) el.scrollLeft = x; });
  }
  function guardaLugar() {
    try { window.history.replaceState(Object.assign({}, window.history.state, { y: window.scrollY }), ''); } catch (e) { /* o Safari recusa replaceState demais */ }
  }
  function escreveUrl(url, empurra) {
    if (!empurra) return;
    guardaLugar();
    try { window.history.pushState({ hitFiltros: true }, '', url.pathname + url.search); } catch (e) { console.error('HitFiltros: não deu para escrever a URL', e); }
  }

  /* O voltar/avançar e o clique na lista que já está na tela não pedem nada, mas um pedido de lista ainda em voo (a escolha anterior) não
     pode mais chegar e trocar a grade debaixo da URL que a pessoa acabou de escolher. */
  function cancelaLista() {
    if (!emVoo) return;
    if (controle) controle.abort();
    controle = null;
    emVoo = null;
    numero += 1;
    tiraEsqueleto();
    realinhaGrade();
  }

  /* opts: { empurra (pushState), lugar (rolagem a devolver no voltar), origem (quem pediu) } */
  async function troca(destino, opts) {
    const o = opts || {};
    const raiz = $(RAIZ);
    const url = urlDe(destino);
    if (!raiz) { window.location.assign(url.href); return false; }
    if (chave(url.href) === atual && o.empurra !== false) { cancelaLista(); return false; } // mesma lista: nada a buscar, e a escolha em voo morre
    if (controle) controle.abort();
    controle = new AbortController();
    const meu = (numero += 1);
    emVoo = { meu };
    const espera = setTimeout(() => { if (meu === numero) mostraEsqueleto(raiz); }, ESPERA_ESQUELETO);
    try {
      const { doc, nova } = await buscaSecao(url, raiz.getAttribute('data-section-id'), controle.signal);
      if (meu !== numero) return false;
      const naGaveta = !!(document.activeElement && document.activeElement.closest && document.activeElement.closest(GAVETA));
      const foco = naGaveta ? chaveDoFoco() : null;
      const noOrdenar = !naGaveta && !!(document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-filtro-ordem]'));
      esq = null; // os filhos vão embora com o esqueleto
      trocaTudo(raiz, nova);
      atual = chave(url.href);
      escreveUrl(url, o.empurra !== false);
      if (o.lugar != null) window.scrollTo(0, o.lugar);
      if (window.HitTrilhos) window.HitTrilhos.sincronizaTrilhos();
      atualizaGaveta(foco);
      if (noOrdenar) {
        const caixa = $('[data-filtro-ordem] select', raiz);
        if (caixa) caixa.focus({ preventScroll: true });
      } else if (!naGaveta && o.origem && !o.origem.isConnected && document.activeElement === document.body) {
        // o chip que a pessoa tirou saiu do DOM: o foco vai para o "Filtrar" da barra (que agora conta um a menos); sem ele, o título
        const alvo = botaoFiltrar(raiz) || $('.tit', raiz);
        if (alvo) { if (alvo.tagName !== 'BUTTON') alvo.setAttribute('tabindex', '-1'); alvo.focus({ preventScroll: true }); }
      }
      const c = $('.conta', raiz);
      anuncia(c ? c.textContent.trim() : '');
      emVoo = null;
      return true;
    } catch (e) {
      if (e && e.name === 'AbortError') return false;
      if (meu !== numero) return false;
      console.error('HitFiltros: a troca falhou', e);
      emVoo = null;
      tiraEsqueleto();
      // voltar/avançar: a URL já é a nova e a grade é a velha, e não há como deixar as duas iguais sem a resposta: recarrega, e o servidor desenha a URL
      if (o.empurra === false) { window.location.reload(); return false; }
      toast(texto('erro'));
      realinhaGrade(); // um voltar em voo que este clique cancelou deixou a barra na URL do voltar, com a grade de antes
      return false;
    } finally {
      clearTimeout(espera);
      if (emVoo && emVoo.meu === meu) emVoo = null;
    }
  }

  /* ---------- gaveta ---------- */
  /* o pé fixo: "Limpar" (um link para a URL sem os filtros, ou um botão apagado quando não há filtro) e "Ver N produtos" (que fecha a gaveta) */
  function montaPe(barra) {
    const pe = document.createElement('div');
    pe.className = 'filtros-pe';
    const href = barra.getAttribute('data-limpar');
    let limpar;
    if (href) {
      limpar = document.createElement('a');
      limpar.href = href;
      limpar.setAttribute('data-filtro-link', '');
    } else {
      limpar = document.createElement('button');
      limpar.type = 'button';
      limpar.disabled = true;
    }
    limpar.className = 'btn sec';
    limpar.setAttribute('data-chave', 'pe|limpar');
    limpar.textContent = texto('limpar-curto');
    const ver = document.createElement('button');
    ver.type = 'button';
    ver.className = 'btn';
    ver.setAttribute('data-filtro-fechar', '');
    ver.setAttribute('data-chave', 'pe|ver');
    ver.textContent = texto('ver') || texto('ver-sem-numero');
    pe.append(limpar, ver);
    return pe;
  }
  function montaGaveta() {
    const fonte = $(FONTE), barra = $(BARRA);
    if (!fonte || !barra) return null;
    const corpo = document.createDocumentFragment();
    $$('.grupo', fonte).forEach((g) => corpo.appendChild(g.cloneNode(true)));
    return { titulo: texto('todos'), corpo, pe: montaPe(barra) };
  }
  function chaveDoFoco() {
    const a = document.activeElement, c = a && a.closest ? a.closest('[data-chave]') : null;
    return c ? c.getAttribute('data-chave') : null;
  }
  /* gaveta aberta: refaz corpo, título e pé no mesmo lugar (B:1472), com a rolagem, o foco e cada acordeão como estavam. Grupo que a
     pessoa já tinha na gaveta mantém o estado dela (aberto ou fechado); grupo novo nasce como a página o desenha (aberto se tem valor ativo) */
  function atualizaGaveta(foco) {
    const g = $(GAVETA);
    if (!g || g.getAttribute('data-gaveta-aberta') !== 'filtros') return;
    const c = montaGaveta();
    if (!c) { if (window.HitGaveta) window.HitGaveta.fechar(); return; }
    const corpo = $('.g-corpo', g), pe = $('.g-pe', g), rolagem = corpo.scrollTop;
    const abertos = new Map($$('details.grupo', corpo).map((d) => [d.getAttribute('data-k'), d.open]));
    $('#g-t', g).textContent = c.titulo;
    corpo.replaceChildren(c.corpo);
    $$('details.grupo', corpo).forEach((d) => { const k = d.getAttribute('data-k'); if (abertos.has(k)) d.open = abertos.get(k); });
    corpo.scrollTop = rolagem;
    pe.replaceChildren(...(c.pe ? [c.pe] : []));
    pe.hidden = !pe.hasChildNodes();
    if (foco === null) return;
    const igual = $$('[data-chave]', g).find((n) => n.getAttribute('data-chave') === foco && !n.disabled);
    const alvo = igual || $('[data-chave="pe|ver"]', pe) || $('.fechar', g);
    if (alvo) alvo.focus({ preventScroll: true });
  }

  /* ---------- ouvintes ---------- */
  function urlDoForm(form, quem) {
    let dados;
    try { dados = new FormData(form, quem || undefined); } catch (e) { dados = new FormData(form); }
    const u = new URL(form.action, window.location.href);
    u.search = '';
    dados.forEach((v, k) => { if (typeof v === 'string') u.searchParams.append(k, v); });
    if (u.searchParams.get('sort_by') === '') u.searchParams.delete('sort_by'); // "Destaques" é a ordem sem parâmetro
    if (form.hasAttribute('data-filtro-preco')) {
      $$('[data-preco-min], [data-preco-max]', form).forEach((input) => { if (input.value === '') u.searchParams.delete(input.name); });
    }
    return u.href;
  }
  function validaPreco(form) {
    const min = $('[data-preco-min]', form), max = $('[data-preco-max]', form), erro = $('[data-preco-erro]', form);
    if (!min || !max || !erro) return true;
    const invalido = min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber;
    erro.hidden = !invalido;
    if (invalido && !erro.id) erro.id = 'filtro-preco-erro-' + (++numeroErroPreco);
    [min, max].forEach((input) => {
      if (invalido) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', erro.id);
      } else {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        input.removeAttribute('aria-description');
      }
    });
    if (invalido) min.focus({ preventScroll: true });
    return !invalido;
  }
  const comTecla = (ev) => ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey;

  // captura: guarda quem abriu a gaveta (o foco volta a ele ao fechar)
  document.addEventListener('click', (ev) => {
    const gat = ev.target instanceof Element ? ev.target.closest('[data-gaveta="filtros"]') : null;
    if (gat) origemGaveta = gat;
  }, true);
  document.addEventListener('click', (ev) => {
    if (ev.defaultPrevented || comTecla(ev) || !(ev.target instanceof Element)) return;
    if (ev.target.closest('[data-filtro-fechar]')) {
      ev.preventDefault();
      if (window.HitGaveta) window.HitGaveta.fechar();
      return;
    }
    const link = ev.target.closest('a[data-filtro-link]');
    if (!link || !$(RAIZ)) return;
    ev.preventDefault();
    troca(link.href, { origem: link });
  });
  document.addEventListener('submit', (ev) => {
    const form = ev.target;
    if (ev.defaultPrevented || !(form instanceof HTMLFormElement) || !form.hasAttribute('data-filtro-form') || !$(RAIZ)) return;
    ev.preventDefault();
    if (form.hasAttribute('data-filtro-preco') && !validaPreco(form)) return;
    troca(urlDoForm(form, ev.submitter), { origem: ev.submitter });
  });
  /* o Ordenar da barra envia ao mudar (sem script há o botão "Aplicar" ao lado). requestSubmit passa pelo ouvinte de submit acima */
  document.addEventListener('change', (ev) => {
    const caixa = ev.target instanceof Element ? ev.target.closest('[data-filtro-ordem] select') : null;
    const form = caixa && caixa.form;
    if (!form || !$(RAIZ)) return;
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
    const envio = new Event('submit', { bubbles: true, cancelable: true });
    if (form.dispatchEvent(envio)) form.submit();
  });
  window.addEventListener('popstate', () => {
    if (!vaiTrocar()) { cancelaLista(); return; } // a lista da tela já é a da URL (ou só a âncora mudou): o pedido em voo morre
    const y = window.history.state && typeof window.history.state.y === 'number' ? window.history.state.y : null;
    troca(window.location.href, { empurra: false, lugar: y });
  });

  /* ---------- foco ao fechar ---------- */
  const visivel = (n) => !!n && n.isConnected && n.getClientRects().length > 0;
  function substitutoDeFoco() {
    const filtrar = $$('[data-gaveta="filtros"]').find(visivel); // o da barra vem antes no documento; o da barra de baixo, se a barra não se vê
    if (filtrar) return filtrar;
    const titulo = $('.tit', $(RAIZ) || document);
    if (titulo) titulo.setAttribute('tabindex', '-1');
    return titulo;
  }
  // o HitCamadas emite hit:camada-fechou ANTES de devolver o foco, e a devolução ignora quem saiu do DOM: aqui o foco já fica no substituto
  document.addEventListener('hit:camada-fechou', (ev) => {
    const g = $(GAVETA);
    if (!g || ev.target !== g || g.getAttribute('data-gaveta-aberta') !== 'filtros') return;
    if (ev.detail && ev.detail.motivo === 'substituida') return;
    const origem = origemGaveta;
    origemGaveta = null;
    if (visivel(origem)) return; // o HitCamadas devolve o foco a ela
    const sub = substitutoDeFoco();
    if (sub) sub.focus({ preventScroll: true });
  });

  function inicia() {
    if (window.HitGaveta) window.HitGaveta.registrar('filtros', montaGaveta);
  }
  // este arquivo é defer e roda ANTES do hit-gaveta.js (que vem depois do conteúdo, no fim do layout): com o documento em "interactive" o
  // HitGaveta ainda não existe, e é no DOMContentLoaded que ele já está lá. Só um arquivo injetado depois do load liga na hora
  if (document.readyState === 'complete') inicia();
  else document.addEventListener('DOMContentLoaded', inicia, { once: true });

  window.HitFiltros = Object.freeze({ vaiTrocar });
})();
